/**
 * <citron-reveal>: adds `is-revealed` the first time a quarter of the element
 * is on screen, then stops observing. The section's CSS does the animation,
 * keyed on `citron-reveal:defined`, so content is never hidden if this script
 * fails to load. Reduced motion reveals immediately.
 */
(() => {
  if (customElements.get('citron-reveal')) return;

  class CitronReveal extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('is-revealed')) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        this.classList.add('is-revealed');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.classList.add('is-revealed');
          this.observer.disconnect();
        },
        { threshold: 0.25 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('citron-reveal', CitronReveal);
})();
